import { defineMessages } from 'react-intl';

export default defineMessages({
  weakPassword: {
    id: 'auth.weakPassword',
    defaultMessage: 'Password should be at least 6 characters',
  },
  emailAlreadyInUse: {
    id: 'auth.emailAlreadyInUse',
    defaultMessage: 'This e-mail is already in use',
  },
  incorrectPassword: {
    id: 'auth.incorrectPassword',
    defaultMessage: 'Provided password is incorrect',
  },
  userNotFound: {
    id: 'auth.userNotFound',
    defaultMessage: 'User not found',
  },
  codeExpired: {
    id: 'auth.codeExpired',
    defaultMessage: 'The action code has expired.',
  },
  unknownError: {
    id: 'auth.unknownError',
    defaultMessage: 'An unknown error has occurred',
  },
  reSignInNeeded: {
    id: 'auth.reSignInNeeded',
    defaultMessage:
      'This operation is sensitive and requires recent authentication. Log in again before retrying this action.',
  },
  resetPasswordLinkIsInactive: {
    id: 'auth.resetPasswordLinkIsInactive',
    defaultMessage: 'Operation is not possible. This link is inactive.',
  },
});
